import {CompanyService} from '../../shared/services/company.service';
import {ActivatedRoute} from '@angular/router';
import {Company} from '../../shared/models/company';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-edit',
  templateUrl: './company-edit.component.html',
  styleUrls: ['./company-edit.component.css']
})
export class CompanyEditComponent implements OnInit {
  private _company:Company;
  private _users:any;
  private _orderStatistics:any;
  
  constructor(private route:ActivatedRoute, private companyService:CompanyService, ) { 
    this.company = new Company();
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let companyID = params['companyId'];
      this.companyService.getCompany(companyID).then((company) => {
        this.company = company;
      })
      .catch((error) => {
        console.error(error);
      });

      this.companyService.getUserStatistics(companyID).then((userStats) => {
        this._users = userStats;
      });

      this.companyService.getOrderStatistics(companyID).then((orderStats) => {
        this._orderStatistics = orderStats;
      });
    });
  }

  public get users() {
    return this._users;
  }

  public get orderStatistics() {
    return this._orderStatistics;
  }

	public get company(): Company {
		return this._company;
	}

	public set company(value: Company) {
		this._company = value;
	}
}



// WEBPACK FOOTER //
// ./src/app/companies-admin/company-edit/company-edit.component.ts